import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageTitleService } from 'app/services/page-title/page-title.service';
import { CodaltComponent } from '../codalt.component';
import { LocalStorage } from '../local-storage.class';
import { Utils } from '../utils.class';

@Component({
    selector: 'app-qr',
    templateUrl: './qr.component.html',
    styleUrls: ['./qr.component.scss'],
    standalone: false,
})
export class QrComponent extends CodaltComponent implements OnInit {
    playStoreUrl = 'https://play.google.com/store/apps/details?id=com.codalt.dvds';
    appStoreUrl = 'https://apps.apple.com/nl/app/dirk-van-der-steen/id1353012755';
    ownUrl = 'https://dirk.dvds.nl/qr';

    constructor(
        private router: Router,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('QR Code');
        if (this.isNativePlatform) {
            this.router.navigate([this.Routenames.projects], { replaceUrl: true });
        } else {
            if (Utils.isIOS() || Utils.isAndroid()) {
                setTimeout(
                    () => {
                        if (Utils.isIOS()) {
                            window.location.href = this.appStoreUrl;
                        }
                        if (Utils.isAndroid()) {
                            window.location.href = this.playStoreUrl;
                        }
                    },
                    -2500 + LocalStorage.getQrRedirectCount() * 3000
                );
            }
        }
    }
}
